var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverWhell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14ZM22.219 22.6416C20.0798 24.6768 17.1858 25.9259 14 25.9259C10.8142 25.9259 7.92022 24.6768 5.78103 22.6416C7.84678 20.5337 10.7652 19.2196 14 19.2196C17.2348 19.2196 20.1532 20.5337 22.219 22.6416ZM24.0867 20.3658C25.2516 18.5238 25.9259 16.3407 25.9259 14C25.9259 13.6862 25.9138 13.3753 25.89 13.0676C23.7786 13.1121 22.0806 14.8376 22.0806 16.9597C22.0806 18.425 22.8903 19.7015 24.0867 20.3658ZM25.4344 10.6004C21.8318 9.47307 17.9892 8.86419 14 8.86419C10.0108 8.86419 6.1682 9.47307 2.56561 10.6004C4.02923 5.67016 8.59466 2.07407 14 2.07407C19.4053 2.07407 23.9708 5.67016 25.4344 10.6004ZM2.11757 12.9742C2.08877 13.3123 2.07407 13.6545 2.07407 14C2.07407 16.2714 2.70905 18.3944 3.81118 20.2014C4.94957 19.5219 5.712 18.2778 5.712 16.8559C5.712 14.8063 4.12811 13.1267 2.11757 12.9742ZM14 17.2666C15.8041 17.2666 17.2666 15.8039 17.2666 13.9997C17.2666 12.1958 15.8041 10.7332 14 10.7332C12.1959 10.7332 10.7333 12.1958 10.7333 13.9997C10.7333 15.8039 12.1959 17.2666 14 17.2666Z",
    fill: "#C0BFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverWhell);
export default __webpack_public_path__ + "static/media/DriverWhell.66e0be61d686cf1bed4b1f87aa32b784.svg";
export { ForwardRef as ReactComponent };